// @flow
import InteractionCapabilities from './component'
import actions from './actions'
import { connect } from 'react-redux'

function mapDispatchToProps (dispatch) {
  return {
    capabilitiesToTestFor: [
      [
        'touchstart',
        (isAble: boolean) =>
          dispatch(actions.interactionCapabilities.touch.set(isAble))
      ],
      [
        'mouseover',
        (isAble: boolean) =>
          dispatch(actions.interactionCapabilities.hover.set(isAble))
      ]
    ]
  }
}

export default connect(undefined, mapDispatchToProps)(InteractionCapabilities)
